import { legacy_createStore as createStore } from "redux";
import rootReducer from "./reducers";
const devToolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f;
const store = createStore(rootReducer, undefined, // no preloaded state
devToolsEnhancer // enhancer passed here
);
export default store;
